import React, { useState } from 'react';
import { ChatItemSnapshot } from '../../slices/chatSlice';
import { ItemInfo } from '../ItemInfo/ItemInfo';
import { getItemDisplayName, getItemNameColor } from '../../util/itemPresentation';
import useTranslator from '../../hooks/translate';

/** Read-only item snapshot: shares inventory tooltips without inventory actions. */
class ItemPreviewBoundary extends React.Component<{ children: React.ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error) { console.error('Chat item preview failed', error); }
  render() { return this.state.failed ? <span style={{ color: '#fff' }}>ไม่สามารถแสดงรายละเอียดไอเท็ม</span> : this.props.children; }
}

export function ChatItemLink({ item }: { item: ChatItemSnapshot }) {
  return <ItemPreviewBoundary><ItemLink item={item} /></ItemPreviewBoundary>;
}

function ItemLink({ item }: { item: ChatItemSnapshot }) {
  const t = useTranslator();
  const [hover, setHover] = useState(false);
  const canPreview = !!item.core;
  return <span
    tabIndex={canPreview ? 0 : undefined}
    style={{ position: 'relative', color: getItemNameColor(item), fontWeight: 'bold', cursor: canPreview ? 'help' : undefined }}
    onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
    onFocus={() => setHover(true)} onBlur={() => setHover(false)}>
    {getItemDisplayName(item, t)}
    {hover && item.core && <span style={{ position: 'absolute', left: 0, top: 0, pointerEvents: 'none', fontWeight: 'normal', color: 'whitesmoke' }}>
      <ItemInfo item={{ ...item, core: item.core, uid: 'chat-preview' }} />
    </span>}
  </span>;
}
